/* eslint-disable  */
import React from 'react'
import { IoClose } from 'react-icons/io5'

function ProductModal({ children, width, height, overflowY = 'auto', title, closeModal, submitFunction }) {
  const handleSubmit = () => {
    alert('he')
  }

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-[9998] p-4">
      <div
        className="relative z-[9999] bg-white rounded-2xl shadow-2xl max-w-[90vw] max-h-[90vh] overflow-hidden"
        style={{ width: `${width}`, height: `${height}` }}
      >
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-gray-100 px-6 py-4 flex justify-between items-center z-10">
          <h3 className="text-xl font-bold text-black">
            {title}
          </h3>
          <button
            type="button"
            className="w-10 h-10 rounded-full bg-gray-100 hover:bg-red-100 text-gray-500 hover:text-red-500 flex items-center justify-center transition-all duration-200"
            onClick={() => closeModal(false)}
          >
            <IoClose className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div
          className="p-6"
          style={{ overflowY: `${overflowY}`, maxHeight: 'calc(90vh - 80px)' }}
        >
          {children}
        </div>
      </div>
    </div>
  )
}

export default ProductModal